/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Tooltip from './Tooltip/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/SendRequestAction/Content",
  hovered,
  onMouseEnterManual,
  onMouseLeaveManual,
  isDisabled
  
}) {
let onClick = fromHelpers.useOnSubmit({
  children,
  viewPath,
  hovered,
  onMouseEnterManual,
  onMouseLeaveManual,
  isDisabled
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnterManual}
 onMouseLeave={onMouseLeaveManual}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={onClick}
 disabled={isDisabled}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send case closer request"
/>
)}
</TysiaButton>
<fromFlow.When is={isDisabled}>
<Tooltip
  viewPath={`${viewPath}/Tooltip`}
 flowNo={!hovered}
 flowContent={hovered}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}